module.exports = {
    API_KEY : "4a1fc76a90fd7469e2d84d145e3b1eab",

    /***************************** Local ************************************/
    // API_ADMIN_URL : "http://localhost:63005/admin/",
    // API_BASE_URL : "http://localhost:63005/",
    // FRONT_BASE_URL : "http://localhost:3000",
    // INVESTOR_LOGIN_URL : "http://localhost:3001/investor-login",
    // COMPANY_LOGIN_URL : "http://localhost:3001/company-login",
    // ASSETS_BASE_URL : "http://localhost:3000",
    
    /***************************** Algodev ************************************/
    // API_ADMIN_URL : "https://algodev.in:63005/admin/",
    // API_BASE_URL : "https://algodev.in:63005/",
    // FRONT_BASE_URL : "https://algodev.in:63010",
    // INVESTOR_LOGIN_URL : "https://algodev.in:63010/investor-login",
    // COMPANY_LOGIN_URL : "https://algodev.in:63010/company-login",


    /***************************** Live ************************************/
    API_ADMIN_URL : "https://api.spotlight.chiratae.com/admin/",
    API_BASE_URL : "https://api.spotlight.chiratae.com/",
    FRONT_BASE_URL : "https://spotlight.chiratae.com",
    INVESTOR_LOGIN_URL : "https://spotlight.chiratae.com/investor-login",
    COMPANY_LOGIN_URL : "https://spotlight.chiratae.com/company-login", 
    ASSETS_BASE_URL : "https://admin.spotlight.chiratae.com",   

    EMAIL_API_URL : "https://chiratae.primeapps.co.in/apiv3/maildata"
}